module.exports = __webpack_public_path__ + "img/products_icon_pink.ca5b6391.svg";